import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import FolderIcon from "@material-ui/icons/Folder";
import React from "react";
import VerPdf from "./VerPdf";

const firebase = require("firebase");
require("firebase/firestore");

export default function Archivos(props) {
  const [open, setOpen] = React.useState(false);
  const [url, setUrl] = React.useState("");

  const handleClickOpen = dir => {
    setOpen(true);
    setUrl(dir);
  };

  const handleCerrar = () => {
    setOpen(false);
  };

  const handleDelete = (archivo, url, nombre) => {
    //  console.log("variable dele: ", archivo);
    const storageRef = firebase.storage().ref();

    var desertRef = storageRef.child(archivo);

    desertRef
      .delete()
      .then(function() {
        console.log("File " + archivo + " deleted successfully");
      })
      .catch(function() {
        console.log("File " + archivo + " NOT deleted successfully");
      });

    props.eliminar(archivo, url, nombre);

    /*  firebase
      .firestore()
      .collection("notes")
      .doc("1Ac2tBooXSLVSiU4Xu1S")
      .update({
        "fase1.fechaReclamoP": firebase.firestore.FieldValue.arrayRemove({
          bucket: archivo,
          nombre: nombre,
          url: url
        })
      });*/
  };

  return (
    <div>
      <Dialog open={props.abrir}>
        <DialogTitle id="listaArchivos">Lista de Archivos: </DialogTitle>
        <DialogContent>
          {props.lista ? (
            <List>
              {props.lista.map(value => {
                console.log(value);
                return (
                  <ListItem
                    key={value.url}
                    button
                    onClick={() => handleClickOpen(value.url)}
                  >
                    <ListItemIcon>
                      <FolderIcon />
                    </ListItemIcon>
                    {value.nombre}
                    <ListItemSecondaryAction>
                      {window.respuesta.checkedF ? (
                        <IconButton
                          onClick={() => {
                            console.log(value);
                            handleDelete(value.bucket, value.url, value.nombre);
                          }}
                          edge="end"
                          aria-label="comments"
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                      ) : null}
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          ) : (
            <DialogContentText>No Hay archivos para mostrar.</DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.cerrar()} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <VerPdf abrir={open} cerrar={handleCerrar} url={url} />
    </div>
  );
}
